// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "ServiceInfo-module--wrapper--BKLPD";
export var squareBlock = "ServiceInfo-module--squareBlock--7Epvz";
export var title = "ServiceInfo-module--title--ScrNS";
export var specialtiesWrapper = "ServiceInfo-module--specialtiesWrapper--hWrXF";
export var helpWrapper = "ServiceInfo-module--helpWrapper--ddWs4";
export var appointmentTypesWrapper = "ServiceInfo-module--appointmentTypesWrapper--0WSju";
export var innerClassName = "ServiceInfo-module--innerClassName--Q0o65";
export var experienceWrapper = "ServiceInfo-module--experienceWrapper--2CLhk";
export var experienceInner = "ServiceInfo-module--experienceInner--9rLTK";
export var number = "ServiceInfo-module--number--CgtIJ";
export var annotation = "ServiceInfo-module--annotation--lLDxI";